<template>
  <div class="career-counselling-page">
    <section class="masthead hero-text-img-section section-bottom-spacing">
      <div class="container-fluid px-0">
        <div class="row justify-content-center mt-10">
          <div class="col-lg-10 text-center">
            <h2 class="secondary-color">CAREER COUNSELLING</h2>
            <h2 class="page-intro-line">
              Navigate Your Path to Global Success
            </h2>
            <p class="main-content-1 mt-2">
              Unlock your potential with Aliff's expert career counseling. We
              help you discover your strengths and plan your path to success.
              Start your journey today.
            </p>
          </div>
        </div>
      </div>
      <div class="hero-img-right career-hero-img">
        <img src="@/assets/imgs/city-img.png" alt="" />
      </div>

      <!-- <div class="intro-tabs">
        <ul class="tabs">
          <li class="tab-content">
            Shortlist Universities and Apply
          </li>
          <li class="tab-content">
            Write outstanding SOP and LORs
          </li>
          <li class="tab-content">
            Financial counselling &amp; Scholarships
          </li>
          <li class="tab-content">
            Secure your visa
          </li>
        </ul>
      </div> -->
    </section>

    <section class="tests-section section-spacing">
      <div class="container">
        <div class="text-center">
          <h2 class="main-heading-1-gradient">STUDENT ABILITY TEST</h2>
          <p>
            <!-- Student Ability Test measures your personality, interest and your
            aptitude. It is a perfect assessment of your strengths and
            weaknesses. You will be able to understand your personality type and
            accordingly choose the future course of action, be it education or
            career. -->
            Discover your true potential with the Student Ability Test! Unveil
            your personality, interests, and aptitude to identify your strengths
            and weaknesses. With this perfect assessment, you can confidently
            chart your future course in education or career. Don't just guess,
            assess!
          </p>
        </div>
        <div class="row align-items-center mt-5">
          <div
            class="col-md-6 order-md-2"
            data-aos="fade-left"
            data-aos-duration="500"
          >
            <div class="text-center">
              <img src="@/assets/imgs/edge-out-1.png" class="img-fluid" />
            </div>
          </div>
          <div
            class="col-md-6 col-xl-6 order-md-1 mt-3 mt-lg-0"
            data-aos="fade-right"
            data-aos-duration="500"
          >
            <div>
              <h2 class="main-heading-1">Mensa Test</h2>
            </div>
            <div>
              <p class="main-content-1">
                <!-- Mensa is the largest and oldest high IQ society in the world. It
                aims to identify and foster human intelligence for the benefit
                of humanity, encourages research in the nature, characteristics,
                and uses of intelligence and provide a stimulating intellectual
                and social environment for its members. The first set of 30
                questions in our Student Ability Test are designed as er Mensa
                Test and aims to measure the intellect in a student. -->
                Join the world's largest and oldest high IQ society - Mensa! Our
                mission is to identify and cultivate human intelligence for the
                betterment of society. Through research, we explore the nature,
                traits, and applications of intelligence while providing our
                members with a dynamic intellectual and social community. Take
                the first step towards uncovering your brilliance with our
                Student Ability Test - featuring the Mensa-inspired initial set
                of 30 questions to measure your intellect.
              </p>
              <!-- <div class="mt-5">
                <button
                  class="btn-secondary-red"
                  @click="$router.push({ path: '/contact-us' })"
                >
                  Let's Connect?
                </button>
              </div> -->
            </div>
          </div>
        </div>
        <div class="row row-2 align-items-center my-lg-5 py-3">
          <div
            class="col-md-6 col-xl-6 order-md-2 mt-3 mt-lg-0"
            data-aos="fade-right"
            data-aos-duration="500"
          >
            <div>
              <h2 class="main-heading-1">Personality Test</h2>
            </div>
            <div>
              <p class="main-content-1">
                <!-- The second section of the Student Ability Test measures the
                personality of the student. This test is designed based on the
                Myers–Briggs Type Indicator. The MBTI is based on the conceptual
                theory proposed by Swiss psychiatrist Carl Jung, who had
                speculated that people experience the world using four principal
                psychological functions – sensation, intuition, feeling, and
                thinking. -->
                Uncover the depths of your personality with the Student Ability
                Test. Inspired by the renowned Myers-Briggs Type Indicator, this
                assessment is based on Carl Jung's theory that individuals use
                four primary psychological functions - sensation, intuition,
                feeling, and thinking - to navigate the world around them. Gain
                invaluable insights into your unique personality traits and
                unlock your full potential.
              </p>
            </div>
            <!-- <div class="mt-5">
                <button
                  class="btn-secondary-red"
                  @click="$router.push({ path: '/contact-us' })"
                >
                  Let's Connect?
                </button>
              </div> -->
          </div>
          <div
            class="col-md-6 order-md-1"
            data-aos="fade-left"
            data-aos-duration="500"
          >
            <div class="text-center">
              <img src="@/assets/imgs/edge-out-2.png" class="img-fluid" />
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <div
            class="col-md-6 order-md-2"
            data-aos="fade-left"
            data-aos-duration="500"
          >
            <div class="text-center">
              <img src="@/assets/imgs/edge-out-3.png" class="img-fluid" />
            </div>
          </div>
          <div
            class="col-md-6 col-xl-6 order-md-1 mt-3 mt-lg-0"
            data-aos="fade-right"
            data-aos-duration="500"
          >
            <div>
              <h2 class="main-heading-1">Interest Test</h2>
            </div>
            <div>
              <p class="main-content-1">
                <!-- The final assessment in Student Ability Test measures the
                Interest in a student. This module is based on the Holland Codes
                or the Holland Occupational Themes (RIASEC) refers to a theory
                of careers and vocational choice (based upon personality types)
                that was initially developed by American psychologist John L.
                Holland. -->
                The Student Ability Test's third and final section unlocks your
                interests! Inspired by the Holland Codes or Holland Occupational
                Themes (RIASEC), this module is based on the career and
                vocational theory developed by renowned psychologist John L.
                Holland. By exploring your personality type and interests, you
                can discover a career path that aligns with your unique
                strengths and passions. Take charge of your future and find your
                calling with the Student Ability Test.
              </p>
            </div>
            <!-- <div class="mt-5">
                <button
                  class="btn-secondary-red"
                  @click="$router.push({ path: '/contact-us' })"
                >
                  Let's Connect?
                </button>
              </div> -->
          </div>
        </div>
      </div>
    </section>

    <section class="pb-xl-5 mb-5 mx-lg-3">
      <div class="gradient-box bg-primary-gradient">
        <div class="w-35">
          <h2 class="mb-1">DO YOU FACE THESE CHALLENGES?</h2>
          <p class="small-para">
            <!-- Interestingly, When we surveyed 735 Indian students about what they
            were struggling with the survey results just underlined what we
            already knew. -->
            We surveyed 735 Indian students about what they were struggling with
            and the majority of them faced these common challenges.
          </p>
        </div>
        <div class="box-content-edge-out">
          <ul class="content-list">
            <li class="content">
              <h1 class="main-heading-1-gradient-small-para">85%</h1>
              <p class="small-size-para">No Career Guidance</p>
            </li>
            <li class="content">
              <h1 class="main-heading-1-gradient-small-para">55%</h1>
              <p class="small-size-para">Lack of Knowledge</p>
            </li>
            <li class="content">
              <h1 class="main-heading-1-gradient-small-para">40%</h1>
              <p class="small-size-para">Family / Peer Influence</p>
            </li>
            <li class="content">
              <h1 class="main-heading-1-gradient-small-para">30%</h1>
              <p class="small-size-para">Can't relate study with career</p>
            </li>
            <li class="content">
              <h1 class="main-heading-1-gradient-small-para">18%</h1>
              <p class="small-size-para">Lack of confidence</p>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="intro-sm-section section-spacing">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-lg-6 responsive-img">
            <img src="@/assets/imgs/mentor.png" class="img-fluid border-all" />
          </div>
          <div class="col-md-6 col-xl-6">
            <h2 class="main-heading-1">Meet Your Mentor</h2>
            <!-- <h2 class="main-heading-1">
              Mentor
            </h2> -->
            <p class="main-content-2 mt-5">
              <!-- You are one of kind and that’s why you need to be matched with a
              unique mentor! Our team is focused, ambitious and unique just like
              you! With visions like yours, they are eager to share tips and
              tricks to search for the best countries, courses, universities,
              and many more with you. -->
              Experience personalized mentorship at our program. Our dedicated
              mentors understand your uniqueness and match your needs. Discover
              the perfect countries, courses, and colleges that align with your
              vision. Unlock your potential and achieve success with our
              unparalleled guidance. Join us and embark on a transformative
              mentoring journey.
            </p>
            <!-- <div class="pt-3 pt-lg-5">
              <button
                class="btn-secondary-red"
                @click="$router.push({ path: '/contact-us' })"
              >
                Let's Connect?
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="university-section section-spacing">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div
            class="col-lg-6 text-center"
          >
            <h2 class="main-heading-1-gradient text-center">
              Meet the counsellers
            </h2>
            <p class="main-content-1">
              A line to speak about featured destination, programme, or
              university. A line to speak about featured destination, programme,
              or university
            </p>
          </div>
          <div class="col-lg-12 mt-3 pt-xl-5">
            <div class="team-member-cards">
              <ul class="cards">
                <li class="team-member">
                  <img src="@/assets/imgs/team-member.png" alt="" />
                  <div class="name-title">Utpal Surname</div>
                  <p class="designation">
                    Counsellor
                  </p>
                </li>
                <li class="team-member">
                  <img src="@/assets/imgs/team-member.png" alt="" />
                  <div class="name-title">Utpal Surname</div>
                  <p class="designation">
                    Counsellor
                  </p>
                </li>
                <li class="team-member">
                  <img src="@/assets/imgs/team-member.png" alt="" />
                  <div class="name-title">Utpal Surname</div>
                  <p class="designation">
                    Counsellor
                  </p>
                </li>
                <li class="team-member">
                  <img src="@/assets/imgs/team-member.png" alt="" />
                  <div class="name-title">Utpal Surname</div>
                  <p class="designation">
                    Counsellor
                  </p>
                </li>
              </ul>
              <ul class="cards">
                <li class="team-member">
                  <img src="@/assets/imgs/team-member.png" alt="" />
                  <div class="name-title">Utpal Surname</div>
                  <p class="designation">
                    Counsellor
                  </p>
                </li>
                <li class="team-member">
                  <img src="@/assets/imgs/team-member.png" alt="" />
                  <div class="name-title">Utpal Surname</div>
                  <p class="designation">
                    Counsellor
                  </p>
                </li>
                <li class="team-member">
                  <img src="@/assets/imgs/team-member.png" alt="" />
                  <div class="name-title">Utpal Surname</div>
                  <p class="designation">
                    Counsellor
                  </p>
                </li>
                <li class="team-member">
                  <img src="@/assets/imgs/team-member.png" alt="" />
                  <div class="name-title">Utpal Surname</div>
                  <p class="designation">
                    Counsellor
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <section class="student-section py-xl-5 my-5">
      <div class="container-fluid bg-row py-5">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center">
            <div class="main-heading-1">
              <!-- We make studying abroad a simple step for you! -->
              Take the leap towards international education with assurance
            </div>
            <div class="main-content-1">
              <!-- Just climb higher without having to look at the cost. Our prices
              are customized to give you an edge without letting you feel any
              burden. -->
              Ascend higher without the financial weight. Our customized prices
              give you the edge you need.
            </div>
          </div>
          <div class="col-lg-12 mt-5">
            <VideoTestimonialSlider
              :testimonialsData="
                testimonialData['career-counselling']['testimonial-2']
              "
            />
          </div>
          <div class="col-lg-12 mt-5 stu-card-section">
            <TextTestimonialSlider
              :testimonialsData="
                testimonialData['career-counselling']['testimonial-1']
              "
            />
          </div>
        </div>
      </div>
    </section>

    <section class="pb-xl-5 mb-5 mx-lg-3">
      <div class="gradient-box bg-primary-gradient">
        <div class="box-title">
          <!-- <h1 class="mb-1">
            Our 10 years of achievements
          </h1> -->
          <h1>With our super powers we have reached here</h1>
        </div>
        <div class="box-content-symbol">
          <ul class="content-list">
            <!-- <img
              src="@/assets/imgs/symbol-data.png"
              class="symbol-data"
              alt=""
            /> -->
            <li class="content">
              <h1>10+</h1>
              <p>Years of experience</p>
            </li>
            <!-- <img
              src="@/assets/imgs/symbol-data.png"
              class="symbol-data"
              alt=""
            /> -->
            <li class="content">
              <h1>98%</h1>
              <p>Admission Rate</p>
            </li>
            <!-- <img
              src="@/assets/imgs/symbol-data.png"
              class="symbol-data"
              alt=""
            /> -->
            <li class="content">
              <h1>19,868</h1>
              <p>Students counselled</p>
            </li>
            <!-- <img
              src="@/assets/imgs/symbol-data.png"
              class="symbol-data"
              alt=""
            /> -->
            <li class="content">
              <h1>32</h1>
              <p>Full scholarship students</p>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="pricing-section section-spacing">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div class="text-center">
              <h2 class="main-heading-1">
                We make studying abroad a simple step for you!
              </h2>
              <p class="main-content-1">
                Just climb higher without having to look at the cost. Our prices
                are customized to give you an edge without letting you feel any
                burden.
              </p>
            </div>
          </div>
          <div class="col-lg-12 pt-5">
            <div class="">
              <slick
                ref="pricingSlider"
                :options="pricingSlider"
                class="pricing-slider"
                v-if="service.plans && service.plans.length > 0"
              >
                <div
                class="pricing-card py-3 px-5 mb-2"
                  v-for="(plan, index) in service.plans"
                  :key="'plan_' + index"
                >
                    <div class="pricing-plan-name">{{ plan.plan_name }}</div>
                    <div class="pricing-cost mb-0">
                      {{
                        getSymbolFromCurrency(
                          plan.pp_currency
                            ? plan.pp_currency
                            : plan.plan_currency
                        )
                      }}
                      {{
                        addCommas(
                          plan.pp_price
                            ? removeGST(plan.pp_price, plan.pp_currency)
                            : removeGST(plan.plan_price, plan.plan_currency)
                        )
                      }}
                    </div>
                    <div
                      class="text-center mb-1"
                      style="color: #999"
                      v-if="
                        plan.plan_currency == 'INR' || plan.pp_currency == 'INR'
                      "
                    >
                      + 18% GST
                    </div>

                    <div class="course-summary mb-1">
                      <div v-html="plan.plan_description"></div>
                    </div>
                    <br /><br />

                    <div class="pricing-btn">
                      <button class="btn btn-pay-now-gradient w-100">
                        <a href="http://app.aliff.in/services">Pay Now</a>
                      </button>
                      <!-- @click="PayNow('pp' + (index + 3))" -->
                      <!-- <div class="plan-route" @click="clickShowPlan()">
                        View & Compare Plans
                      </div> -->
                    </div>
                  </div>
              </slick>
            </div>
            <div
              class="pricing-plan-table animate__animated animate__pulse table-responsive"
            >
              <table class="table">
                <thead class="header">
                  <tr>
                    <th class="plan-lg-title">Compare Plans</th>
                    <th
                      v-for="(plan, index) in service.plans"
                      :key="'plan_compare_' + plan.plan_id + '_' + index"
                    >
                      <div class="text-center">
                        <div class="plan-name">{{ plan.plan_name }}</div>
                        <!-- <div class="plan-price">
                          {{
                            getSymbolFromCurrency(
                              plan.pp_currency
                                ? plan.pp_currency
                                : plan.plan_currency
                            )
                          }}
                          {{
                            addCommas(
                              plan.pp_price
                                ? removeGST(plan.pp_price, plan.pp_currency)
                                : removeGST(plan.plan_price, plan.plan_currency)
                            )
                          }}
                        </div> -->
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody
                  class="alternate-stripped"
                  v-for="(feature, feature_index) in service.features"
                  :key="'feature_' + feature.feature_id + '_' + feature_index"
                >
                  <tr>
                    <td>{{ feature.feature_name }}</td>
                    <td v-for="(plan, index) in service.plans" :key="index">
                      <span v-if="plan.plan_features[feature_index].extra_text">
                        {{ plan.plan_features[feature_index].extra_text }}
                      </span>
                      <img
                        v-else-if="plan.plan_features[feature_index].spfm_id"
                        src="@/assets/imgs/blue-tick.svg"
                        class="img-fluid"
                      />
                      <img
                        v-else
                        src="@/assets/imgs/red-cross.svg"
                        class="img-fluid"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>

    <ContactusSection :source="24"/>
    <RecentPostSection
      :recentPostsData="recentPostData['career-page']['data-1']"
    />
  </div>
</template>

<script>
import homeServices from "@/apiServices/homeServices";
import BookFreeCounselling from "@/components/partials/BookFreeCounselling.vue";
import { DASHBOARD_REGISTER_URL } from "@/config";
import VideoTestimonialSlider from "@/components/partials/VideoTestimonialSlider.vue";
import TextTestimonialSlider from "@/components/partials/TextTestimonialSlider.vue";
import RecentPostSection from "@/components/partials/RecentPostSection.vue";
import ContactusSection from "@/components/partials/ContactusSection.vue";
import getSymbolFromCurrency from "currency-symbol-map";

export default {
  metaInfo: {
      title:
        "Navigate Your Career Path with Aliff's Professional Counseling",
      htmlAttrs: {
        lang: "en-US",
      },
    },
  components: {
    BookFreeCounselling,
    VideoTestimonialSlider,
    TextTestimonialSlider,
    RecentPostSection,
    ContactusSection,
  },
  data() {
    return {
      service: [],
      // showPlan: false,
      DASHBOARD_REGISTER_URL,
      videoSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: true,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 2.5,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      pricingSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },

      postSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: true,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  methods: {
    getSymbolFromCurrency,
    removeGST(total, currency) {
      if (currency != "INR") {
        return total;
      }

      let taxPercentage = 0.18;
      let withTaxAmount = total / (1 + taxPercentage);
      return withTaxAmount.toFixed(0);
    },
    PayNow(pp) {
      var elms = document.getElementById(pp).getElementsByTagName("a");
      elms[0].click();
    },
    // clickShowPlan() {
    //   this.showPlan = !this.showPlan;
    // },
    async getServicePlan() {
      try {
        const response = await homeServices.getServicesAndPlans({
          service_id: 5,
        });

        if (response.data.status) {
          this.service = response.data.data[0];
          console.log(this.service);
        }
      } catch (err) {
        console.log("Error in getting getServicePlan ", err);
      }
    },
    addCommas(amt) {
      return amt.toLocaleString("en-IN");
    },
  },
  beforeMount() {
    document.querySelector('meta[name="description"]').setAttribute('content',"Looking for career counseling? Aliff provides personalized guidance to help you navigate your career path and make informed decisions.");
    this.getServicePlan();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/CareerCounselling.vue